import React, {Component} from 'react'
import NotFound from './NotFound'
import '../../SearchResult/Layout/SearchResult.css'

class NotFoundScreen extends Component {
  render () {
    return (
      <div className="not-found-screen">
        <NotFound route={this.props.location} />
      </div>
    )
  }
}

NotFoundScreen.contextTypes = {
  router: React.PropTypes.object
}

export default NotFoundScreen



// WEBPACK FOOTER //
// ./src/components/Common/NotFound/NotFoundScreen.js